import consumer from "./channels/consumer";

const FRAME_ID = "easy-notification-center";
const PANEL_BODY_ID = "easy_servicebar_component_body";
const TRIGGER_ID = "easy_notification_center_trigger";
const BADGE_ID = "easy_notification_center_badge";

// The legacy panel empties its body on close, removing the frame the feed loads into.
const ensureFrame = () => {
  const existing = document.getElementById(FRAME_ID);
  if (existing) return existing;

  const body = document.getElementById(PANEL_BODY_ID);
  if (!body) return null;

  const frame = document.createElement("turbo-frame");
  frame.id = FRAME_ID;
  body.appendChild(frame);
  return frame;
};

/**
 * Inline click handler of the service-bar bell. Returns true (follow the link to the full page)
 * whenever Turbo or the legacy sliding panel is not available yet.
 */
export const openNotificationCenter = trigger => {
  const jQuery = window.jQuery;
  if (!window.Turbo || !jQuery || !jQuery.fn.easySlidingPanel) return true;

  const frame = ensureFrame();
  if (!frame) return true;

  frame.src = trigger.href;
  jQuery("#easy_servicebar_component").easySlidingPanel({ trigger: `#${trigger.id}` });
  return false;
};

/**
 * EasyNotificationChannel message: updates the bell badge and, while the panel is open,
 * re-fetches its list so the newest card lands on top.
 * @param {{ unseen_count: number }} data
 */
export const handleNotificationPush = data => {
  const badge = document.getElementById(BADGE_ID);
  if (badge) {
    const count = Number(data.unseen_count) || 0;
    badge.textContent = count > 0 ? String(count) : "";
    badge.hidden = count === 0;
  }

  // The frame exists only while the panel is open; the panel close handler removes it.
  const frame = document.getElementById(FRAME_ID);
  if (frame && typeof frame.reload === "function") frame.reload();
};

/**
 * Subscribes the current tab to its notification stream. The bell is rendered only for logged-in
 * users with the center enabled, so its absence means there is nothing to listen to.
 * @returns {Object|null} the Action Cable subscription
 */
export const subscribeNotificationCenter = () => {
  if (!document.getElementById(TRIGGER_ID)) return null;

  return consumer.subscriptions.create("EasyNotificationChannel", {
    // Runs after every confirmed (re)subscription; the server answers with the count through `received`.
    connected() {
      this.perform("refresh");
    },
    received: handleNotificationPush,
  });
};
